import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f23a9e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-width mt-3 mt-lg-0 min-vh-80" }
const _hoisted_2 = { class: "card card-form" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex position-absolute w-100 h-100 align-items-center justify-content-center",
  style: {"background-color":"rgba(255, 255, 255, 0.5)"}
}
const _hoisted_4 = { class: "d-block text-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-success",
  role: "status"
}, null, -1))
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { key: "incomplete" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title text-center fw-bold" }, "Crear una contraseña", -1))
const _hoisted_9 = { class: "row gy-3" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "row my-3" }
const _hoisted_13 = { class: "col-6 col-md-6 d-flex justify-content-start" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6 col-md-6 d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary px-4 py-2 text-uppercase",
    type: "submit"
  }, "Enviar")
], -1))
const _hoisted_15 = {
  class: "text-center p-4",
  key: "complete"
}
const _hoisted_16 = { class: "mb-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormPassword = _resolveComponent("FormPassword")!
  const _component_FormPasswordConfirm = _resolveComponent("FormPasswordConfirm")!
  const _component_Form = _resolveComponent("Form")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading.status)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("h6", null, _toDisplayString(_ctx.loading.text), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        (!_ctx.complete)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_Form, { onSubmit: _ctx.submitForm }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_FormPassword, {
                        modelValue: _ctx.form.password,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.password) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_FormPasswordConfirm, {
                        modelValue: _ctx.form.password_confirmation,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password_confirmation) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", {
                        class: "btn btn-primary px-4 py-2 text-uppercase",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.backClick && _ctx.backClick(...args)), ["prevent"]))
                      }, "Salir")
                    ]),
                    _hoisted_14
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.complete), 1),
              _createVNode(_component_router_link, {
                tag: "button",
                to: {
              name: 'Home'
            },
                class: "btn btn-danger text-center d-inline"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Comenzar a navegar ")
                ]),
                _: 1
              })
            ]))
      ])
    ])
  ]))
}